import User from 'flarum/common/models/User';
import { extend } from 'flarum/common/extend';

// Admin > Mod > Member - Flarum's own fixed built-in group ids. A user in
// several of these (or in one of the hidden société/SPECIES groups on top)
// shows only the single highest one - e.g. an admin who's also a mod and a
// société member shows just "Administrateur".
const BADGE_PRIORITY = ['1', '4', '3'];
export default function showHighestGroupBadgeOnly() {
  extend(User.prototype, 'badges', function (items) {
    const groups = this.groups() || [];
    const ids = groups.map(g => g?.id());
    const highest = BADGE_PRIORITY.find(id => ids.includes(id));
    groups.forEach(group => {
      if (group?.id() !== highest) {
        items.remove(`group${group?.id()}`);
      }
    });
  });
}